import {
  CURRENCY_OPTIONS_RU,
  CURRENCY_OPTIONS_TEACHER_RU,
  CURRENCY_OPTIONS_PL,
  CURRENCY_OPTIONS_TEACHER_PL,
} from 'components/constants/common';

export {
  WEEK_DAYS,
  weekDays,
  weekDayShortLabels,
  WEEK_DAY_KEYS,
  TIME_OPTIONS,
  DEFAULT_LESSON_START_OPTION,
  DEFAULT_LESSON_END_OPTION,
  invalidPhoneError,
  MONTH_NAMES,
  TEACHER_TYPE_OPTIONS,
  TEACHER_TYPE_COUNT_FIELDS,
} from './common';

export { LAYERS } from './layers';
export {
  HEADER_COMPACT_MAX,
  HEADER_COMPACT_MEDIA,
  HEADER_MID_MAX,
  HEADER_MID_MEDIA,
} from './headerBreakpoints';
export {
  MOBILE_MAX,
  TABLET_MAX,
  MOBILE_HEADER_HEIGHT,
  MOBILE_TABBAR_HEIGHT,
  MEDIA_QUERIES,
  mq,
} from './breakpoints';

const isPLN = process.env.REACT_APP_LANG === 'pl';
const CURRENCY_OPTIONS = isPLN ? CURRENCY_OPTIONS_PL : CURRENCY_OPTIONS_RU;
const CURRENCY_OPTIONS_TEACHER = isPLN
  ? CURRENCY_OPTIONS_TEACHER_PL
  : CURRENCY_OPTIONS_TEACHER_RU;

export { CURRENCY_OPTIONS, CURRENCY_OPTIONS_TEACHER };
